import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import FormFieldBase from './FieldBase';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputCheckbox from '../input/Checkbox';
/**@param {import('./types').FinalFormFieldCheckBoxProps} props */

var CheckboxFormField = function CheckboxFormField(_ref) {
  var _ref$input = _ref.input,
      checked = _ref$input.checked,
      name = _ref$input.name,
      onChange = _ref$input.onChange,
      restInput = _objectWithoutProperties(_ref$input, ["checked", "name", "onChange"]),
      meta = _ref.meta,
      label = _ref.label,
      labelPlacement = _ref.labelPlacement,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, ["input", "meta", "label", "labelPlacement", "disabled"]);

  var error = meta.touched && meta.error;
  return React.createElement(React.Fragment, null, React.createElement(FormControl, {
    error: error
  }, React.createElement(InputCheckbox, Object.assign({}, rest, {
    label: label,
    labelPlacement: labelPlacement,
    disabled: disabled,
    name: name,
    inputProps: restInput,
    onChange: onChange,
    checked: !!checked
  })), error && React.createElement(FormHelperText, null, error)));
};

export var Checkbox = function Checkbox(_ref2) {
  var name = _ref2.name,
      rest = _objectWithoutProperties(_ref2, ["name"]);

  return React.createElement(FormFieldBase, Object.assign({
    name: name,
    label: name
  }, rest));
};
Checkbox.defaultProps = {
  type: 'checkbox',
  // fullWidth: true,
  component: CheckboxFormField
};
export default CheckboxFormField;